export class IFilterModel {
  allergens?: any[];
  productGroups?: any[];
  hasMotive?: boolean;
  canHasMotive: boolean;

  postNumber?: string;
  categoryId?: number;
}
